// extracted by mini-css-extract-plugin
module.exports = {"form":"excuteDetailModal_form__W-zXx","moveBtn":"excuteDetailModal_moveBtn__3DoY9","addModal":"excuteDetailModal_addModal__3EbK1"};